/* eslint-disable no-param-reassign */
import { readable, writable } from 'svelte/store';

export const availableSorts = readable([
  {
    label: 'Relevance',
    sortBy: 'relevance',
    sortOrder: 'desc',
  },
  {
    label: 'Recommended',
    sortBy: 'collection_XXX_position',
    sortOrder: 'asc',
  },
  {
    label: 'Best Selling',
    sortBy: 'sales_amount',
    sortOrder: 'desc',
  },
  {
    label: 'Alphabetical (A-Z)',
    sortBy: 'title',
    sortOrder: 'asc',
  },
  {
    label: 'Alphabetical (Z-A)',
    sortBy: 'title',
    sortOrder: 'desc',
  },
  {
    label: 'Newest',
    sortBy: 'created',
    sortOrder: 'desc',
  },
  {
    label: 'Oldest',
    sortBy: 'created',
    sortOrder: 'asc',
  },
  {
    label: 'Price (High - Low)',
    sortBy: 'price',
    sortOrder: 'desc',
  },
  {
    label: 'Price (Low - High)',
    sortBy: 'price',
    sortOrder: 'asc',
  },
]);

export const currentSorts = writable({});
